import axios from "../scripts/axiosConfig";
import { useEffect, useState } from "react";

const currentDate = "-";
const commitMessage = "-";

export default function Meta() {

    useEffect(() => {
        axios.get("/meta")
            .then(res => {
                console.log("%c META", "color: green; font-size: 16px; font-weight: bold");
                console.log(res.data);
            })
            .catch(err => console.error(err))
    
    })


    return (
        <div style={ {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
        } }>

            <ul>
                <li>Author: <a href="https://www.github.com/sabzdotpy" target="_blank" rel="noreferrer">sabzdotpy</a></li>
                <li>Status: prod</li>
                <li>Last Updated: {currentDate}</li>
                <li>Latest commit message: {commitMessage}</li>
            </ul>

            <button
                onClick={() => {
                    throw new Error("Breaking the page intentionally.");
                }}
            >
                Break the Page
            </button>


        </div>
    )
}
